var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "h1",
        {
          directives: [
            {
              name: "resize-text",
              rawName: "v-resize-text",
              value: { maxFontSize: "36pt" },
              expression: "{ maxFontSize: '36pt' }"
            }
          ],
          staticClass: "heading mb-3 ml-5"
        },
        [_vm._v("RESERVES")]
      ),
      _vm._v(" "),
      _c(
        "v-tabs",
        {
          attrs: {
            "background-color": "primary",
            "slider-size": 6,
            "slider-color": "active",
            "fixed-tabs": ""
          },
          model: {
            value: _vm.tabModel,
            callback: function($$v) {
              _vm.tabModel = $$v
            },
            expression: "tabModel"
          }
        },
        [
          _vm._l(Object.keys(_vm.reserves), function(k, i) {
            return _c("v-tab", { key: "tab_" + k + i, attrs: { ripple: "" } }, [
              _vm._v("\n      " + _vm._s(k) + "\n    ")
            ])
          }),
          _vm._v(" "),
          _vm._l(Object.keys(_vm.reserves), function(k, i) {
            return _c(
              "v-tab-item",
              { key: "titem_" + k + i + "desc" },
              [
                _c(
                  "v-container",
                  [
                    _c(
                      "v-row",
                      { attrs: { justify: "center" } },
                      _vm._l(_vm.reserves[k], function(r) {
                        return _c("reserve-card", {
                          key: r.ID,
                          attrs: { reserve: r }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }